import { Table } from 'antd';
import { FC } from 'react';
import styled from 'styled-components/macro';
import { TableProps } from 'antd/lib/table';

export const TableWithStyles = styled(Table)`
  word-break: normal;
  .ant-table-thead {
    white-space: nowrap;
  }
`;

export const StyledTable = <TData,>(props: TableProps<TData>) => {
  return (
    <TableWithStyles<FC<TableProps<TData>>> scroll={{ x: true }} {...props} />
  );
};
